// chats.actions.ts
import { createAction, props } from '@ngrx/store';
import { ChatUser, Message } from './chats.model';

export const chatActions = {};

export const loadChatUsers = createAction(
  '[Chat] Load Chat Users',
  props<{ id: number }>());
export const loadChatUsersSuccess = createAction(
  '[Chat] Load Chat Users Success',
  props<{ users: ChatUser[] }>()
);
export const loadChatUsersFailure = createAction(
  '[Chat] Load Chat Users Failure',
  props<{ error: string }>()
);

export const loadMessages = createAction(
  '[Chat] Load Messages',
  props<{ senderId: number; receiverId: number }>()
);
export const loadMessagesSuccess = createAction(
  '[Chat] Load Messages Success',
  props<{ messages: Message[] }>()
);
export const loadMessagesFailure = createAction(
  '[Chat] Load Messages Failure',
  props<{ error: string }>()
);

export const sendMessage = createAction(
  '[Chat] Send Message',
  props<{ message: Message }>()
);
export const addMessage = createAction(
  '[Chat] Add Message',
  props<{ message: Message }>()
);

export const setCurrentChatUser = createAction(
  '[Chat] Set Current Chat User',
  props<{ user: ChatUser | null }>()
);
